import React, { useState } from "react";
import defaultCroupierImage from "../../../../assets/casino/croupier.png";
import pogImage from "../../../../assets/casino/pog.png";
import leftArrows from "../../../../assets/casino/leftarrows.gif";
import rightArrows from "../../../../assets/casino/rightarrows.gif";
import slideUpImage from "../../../../assets/casino/slideup.png";
import RouletteLatestField from "./RouletteLatestField";
import { formatPogs } from "./rouletteConstants";

function RouletteCroupierPanel({
  bets,
  balance,
  draftTotalStake,
  availableBalance,
  readOnly,
  locking,
  latestResults,
  onLock,
  onClearDrafts,
  onBack,
  croupierImage = defaultCroupierImage,
  hideFigure = false,
  variant = "drawer",
}) {
  const [open, setOpen] = useState(false);
  const isDrawer = variant === "drawer";
  const lockLabel = readOnly ? "LOCKED" : locking ? "LOCKING" : "LOCK";
  const lockDisabled = readOnly || locking || bets.length === 0;
  const clearDraftsDisabled = readOnly || locking || bets.length === 0;
  const drawerId = isDrawer ? "roulette-croupier-drawer" : undefined;

  return (
    <aside
      className={[
        "roulette-croupier-panel",
        `roulette-croupier-panel-${variant}`,
        isDrawer && open ? "is-open" : "",
        !isDrawer && hideFigure
          ? "roulette-croupier-panel-hide-figure"
          : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {isDrawer && open && (
        <div
          className="roulette-croupier-modal-backdrop"
          aria-hidden="true"
        />
      )}

      <div className="roulette-croupier-stack">
        <div
          className="roulette-croupier-figure"
          aria-hidden="true"
        >
          <img
            src={croupierImage}
            alt=""
            draggable="false"
          />
        </div>

        {isDrawer && (
          <button
            type="button"
            className="roulette-croupier-toggle"
            aria-expanded={open}
            aria-controls={drawerId}
            onClick={() => setOpen((current) => !current)}
          >
            {!open && (
              <img
                className="roulette-croupier-toggle-arrow roulette-croupier-toggle-arrow-left"
                src={leftArrows}
                alt=""
                aria-hidden="true"
                draggable="false"
              />
            )}

            <span className="roulette-croupier-toggle-label">
              CROUPIER
            </span>

            {!open && (
              <img
                className="roulette-croupier-toggle-arrow roulette-croupier-toggle-arrow-right"
                src={rightArrows}
                alt=""
                aria-hidden="true"
                draggable="false"
              />
            )}
          </button>
        )}

        <div
          id={drawerId}
          className="roulette-croupier-drawer"
        >
          <div className="roulette-croupier-drawer-inner">
            <div className="roulette-croupier-body">
              <div className="roulette-croupier-title">CROUPIER</div>

              {isDrawer && (
                <RouletteLatestField latestResults={latestResults} />
              )}

              <div className="roulette-croupier-actions">
                <button
                  type="button"
                  className="casino-button"
                  onClick={onLock}
                  disabled={lockDisabled}
                >
                  {lockLabel}
                </button>

                <button
                  type="button"
                  className="casino-button casino-button-secondary"
                  onClick={onBack}
                >
                  BACK
                </button>

                <button
                  type="button"
                  className="casino-button roulette-croupier-clear-drafts"
                  onClick={onClearDrafts}
                  disabled={clearDraftsDisabled}
                >
                  CLEAR DRAFTS
                </button>
              </div>

              <div className="roulette-croupier-metrics">
                <div>
                  <span>POG BALANCE</span>
                  <strong className="roulette-croupier-pog-value">
                    {Number(balance) !== 0 && (
                      <img
                        className="roulette-croupier-pog-icon"
                        src={pogImage}
                        alt=""
                        aria-hidden="true"
                        draggable="false"
                      />
                    )}
                    {formatPogs(balance)}
                  </strong>
                </div>

                <div>
                  <span>{readOnly ? "LOCKED STAKE" : "DRAFT STAKE"}</span>
                  <strong className="roulette-croupier-pog-value">
                    {Number(draftTotalStake) !== 0 && (
                      <img
                        className="roulette-croupier-pog-icon"
                        src={pogImage}
                        alt=""
                        aria-hidden="true"
                        draggable="false"
                      />
                    )}
                    {formatPogs(draftTotalStake)}
                  </strong>
                </div>

                <div>
                  <span>AVAILABLE</span>
                  <strong className="roulette-croupier-pog-value">
                    {Number(availableBalance) !== 0 && (
                      <img
                        className="roulette-croupier-pog-icon"
                        src={pogImage}
                        alt=""
                        aria-hidden="true"
                        draggable="false"
                      />
                    )}
                    {formatPogs(availableBalance)}
                  </strong>
                </div>

                <div>
                  <span>WAGERS</span>
                  <strong>{bets.length}</strong>
                </div>
              </div>

              {isDrawer && open && (
                <button
                  type="button"
                  className="roulette-croupier-slideup"
                  aria-label="Close Croupier"
                  onClick={() => setOpen(false)}
                >
                  <img
                    src={slideUpImage}
                    alt=""
                    aria-hidden="true"
                    draggable="false"
                  />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}

export default RouletteCroupierPanel;
